import { render, staticRenderFns } from "./MedCard.vue?vue&type=template&id=6f576507&scoped=true"
import script from "./MedCard.vue?vue&type=script&lang=js"
export * from "./MedCard.vue?vue&type=script&lang=js"
import style0 from "./MedCard.vue?vue&type=style&index=0&id=6f576507&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f576507",
  null
  
)

export default component.exports